import React from 'react';
import { connect } from 'react-redux';
import { AlTemplatePhysPerfTestRow } from 'PatientCareCenter/Note/AL/Templates';
import styles from './Common.module.css';


class AlTemplatePhysPerfTest extends React.Component {

    render() {
        if (this.props.activities.length > 0) {
            return (
                <div className={styles.section_wrapper}>
                    <div className={styles.header_row}>Physical Performance Test or Measurement</div>

                    {Object.keys(this.props.activities)
                        .map(key => {
                            const result = this.props.activities[key];
                            return (
                                <AlTemplatePhysPerfTestRow key={result.XLTMPSZNO} id={result.XLTMPSZNO} />
                            )
                        })
                    }
                </div>
            );
        } else {
            return (<span />);
        }
    }
}

function mapStateToProps(state) {
    let noteId = state.ui.patientTabs[state.ui.patientCenter[state.ui.patients.selectedPtno].selectedTab].noteId;

    return {
        activities: state.entities.notes.MLTMPSPECIALTYTESTS ?
            Object.keys(state.entities.notes.MLTMPSPECIALTYTESTS)
                .filter(key => {
                    return (state.entities.notes.MLTMPSPECIALTYTESTS[key].NoteId === noteId)
                })
                .sort((a, b) => state.entities.notes.MLTMPSPECIALTYTESTS[a].XLTMPSZORDER - state.entities.notes.MLTMPSPECIALTYTESTS[b].XLTMPSZORDER)
                .map(key => state.entities.notes.MLTMPSPECIALTYTESTS[key]) : [],
    };
}

const connectedAlTemplatePhysPerfTest = connect(mapStateToProps)(AlTemplatePhysPerfTest);
export { connectedAlTemplatePhysPerfTest as AlTemplatePhysPerfTest };

